import React, { useState } from "react";
import styles from "./toggle.module.css";

const REACT_APP_SERVER_URL = process.env.REACT_APP_SERVER_URL;
const ToggleSwitch = ({
  nextOnlinePayment,
  api,
  id,
  type,
  isSomethingChanged,
  setIsSomethingChanged,
  setSelectedApp,
  isSomethingChanged1,
  setIsSomethingChanged1,
}) => {
  const [enabled, setEnabled] = useState(nextOnlinePayment ? true : false);
  const [loading, setLoading] = useState(false);

  const handleToggle = () => {
    setLoading(true);
    fetch(`${REACT_APP_SERVER_URL}/${api}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: JSON.stringify({
        enabled: !enabled,
        id: id,
        type: type,
      }),
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .then((data) => {
        setLoading(false);
        if (data.status === 200) {
          setEnabled(!enabled);

          if (type === "workspace") {
            setIsSomethingChanged1(!isSomethingChanged1);
          } else {
            setIsSomethingChanged(!isSomethingChanged);
            setSelectedApp({});
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className={styles.container}>
      Next {type === "workspace" ? "Subscription" : "payment"} Online
      <button
        onClick={handleToggle}
        disabled={loading}
        className={`${styles.toggle} ${enabled ? styles.enabled : styles.disabled}`}
      >
        <span
          className={`${styles.thumb} ${enabled ? styles.thumbEnabled : ""}`}
        />
      </button>
      {loading && <div className={styles.loader} />}
      <span className={styles.statusText}>
        {loading ? "Processing..." : enabled ? "Enabled" : "Disabled"}
      </span>
    </div>
  );
};

export default ToggleSwitch;
